module.exports = __webpack_public_path__ + "static/roboto-v18-latin-italic-39c358e4c78546f0f49e624bcbdc8e63.svg";